export default __webpack_public_path__ + "static/media/play.905d875b.svg";